import React from 'react';
import Popup from 'components/popups/popup';
import I18n from 'lib/i18n/i18n';
import {dollarsWithoutCents, isMobile, imageUrl, rootUrl} from 'helpers/ApplicationHelper';
import SoldItemPreview from 'components/soldItemPreview';
import {chatBotSaveLog} from 'actions/item';


export class PopupSimilarItems extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    content() {
        const item = this.props.item;
        let content = '';
        if (item.similar_items.length > 1) {
            const subTitle = I18n.getString('itemPage::popupSimilarItems::subtitle').replace("{item_desc}", item.desc || item.name)
            const title = I18n.getString('itemPage::popupSimilarItems::title');
            const exploreMore = I18n.getString('itemPage::popupSimilarItems::exploreMore');
            const exploreMarketplace = isMobile() ? null : <button onClick={this.goToMarketplace} className='btn btn-secondary'>{exploreMore}</button>;
            const similarItems = item.similar_items.sort((a,b) => b.sold_for - a.sold_for).slice(0,4);
            content =  <div className="estimation">
                            <div className="similar-items estimation">
                                <h3 className="title"> {title} </h3>
                                <p className="description" dangerouslySetInnerHTML={ {__html: subTitle}}/>
                                <div className="similar-items-container">
                                    {similarItems.map(item => {return <SoldItemPreview key={item.id} item={item}/>})}
                                </div>
                            </div>
                            {exploreMarketplace}
                        </div>
        } else {
            const exploreTitle = I18n.getString('itemPage::popupSimilarItems::noSimilar::explore');
            const message = I18n.getString('itemPage::popupSimilarItems::noSimilar::message');
            const CTA = I18n.getString('itemPage::popupSimilarItems::noSimilar::CTA');
            content = <div className="no-similar-items">
                            <img className="diamond-ring-icon" src={imageUrl('chatBot/diamond-ring.svg')}/>
                            <h3> {exploreTitle} </h3>
                            <p dangerouslySetInnerHTML={ {__html: message}}/>
                            <button className="btn btn-gold" onClick={this.goToMarketplace}>{CTA}</button>
                      </div>
        }
        return (
            <div>
                {content}
            </div>
        );
    }

    goToMarketplace = () => {
        chatBotSaveLog(this.props.item.id, {key: 'explore_market_place_button_clicked', direction: '1', type: 'message', text: 'Explore marketplace button clicked'}, this.state.conversationVersion);
        window.open(rootUrl('/about/recent-deals/rings'),'_newtab');
    }
}
PopupSimilarItems.defaultProps = {
    popupClassName: 'popup-tooltip popup-tooltip-similar-items popup-compact popup-estimation',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

export class PopupSimilarAuctionedItems extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    componentDidMount() {
        this.props.onOpen && this.props.onOpen();
    }

    componentWillUnmount() {
        this.props.onClose && this.props.onClose();
    }

    title() {
        return I18n.getString('itemPage::popupSimilarAuctionItems::title');
    }

    subTitle() {
        return I18n.getString('itemPage::popupSimilarAuctionItems::text1');
    }

    content() {
        return (
            <div>
                <div className={`similar-items ${this.props.auction_done ? 'auction_done' : ''}`}>
                    <div className={`text ${this.props.auction_done ? 'hidden' : ''}`}>{this.subTitle()}</div>
                    {
                        (()=> {
                            let retArr = [];
                            for (let i in this.props.items) {
                                let item = this.props.items[i];
                                retArr.push(
                                    <figure key={`similar-item-figure-${i}`}>
                                        <img src={item.thumb}/>
                                        <figcaption>{item.name}</figcaption>
                                        {
                                            (()=> {
                                                if (this.props.auction_done){
                                                    return (<div
                                                        className="minimum-price">{I18n.getJsx('itemPage::popupSimilarAuctionItems::soldFor', {
                                                        price: <span>{dollarsWithoutCents(item.reserve_price)}</span>
                                                    })}</div>)

                                                } else
                                                {
                                                    return (
                                                        <div>
                                                            <div
                                                                className="minimum-price">{I18n.getJsx('itemPage::pendingAuction::similarItemsPopup::minimumPrice', {
                                                                price: <span>{dollarsWithoutCents(item.sold_for)}</span>
                                                            })}</div>,
                                                            <div
                                                                className="buy-it-now-price">{I18n.getJsx('itemPage::popupSimilarAuctionItems::buyItBowPrice', {
                                                                price: <span>{dollarsWithoutCents(item.buy_it_now_price)}</span>
                                                            })}</div>
                                                        </div>
                                                    )
                                                }
                                            })()
                                        }

                                    </figure>
                                );
                            }
                            return retArr;
                        })()
                    }
                </div>
            </div>
        );
    }
}
PopupSimilarAuctionedItems.defaultProps = {
    popupClassName: 'popup-tooltip popup-tooltip-similar-items popup-compact',
    single: true,
    modal: true,
    classNames: ['no-animation']
};
